<template>
    <z-checkbox-group class="phonecheckbox" v-model="result">
      <div class="boldtitle">请选择问题类型 <span>（可多选）</span> </div>
      <z-checkbox
        v-for="(item, index) in desc"
        :key="index"
        :name="item.id"
      >
        <div class="content">
          <div class="title">{{ item.title }}</div>
          <div class="tip">{{ item.tip }}</div>
        </div>
      </z-checkbox>
    </z-checkbox-group>
</template>

<script>
import { Checkbox, CheckboxGroup } from '@zz-common/zz-ui'
export default {
  name: 'PhoneCheckBox',
  components: {
    'z-checkbox': Checkbox,
    'z-checkbox-group': CheckboxGroup
  },
  props: {
    Finished: {
      type: Function,
      default: () => {}
    } //向外传递数据
  },
  data() {
    return {
      desc: [
        {
          id: 0,
          title: '手机配置问题',
          tip: '包括手机内存、型号、网络制式、购买渠道、保修期、电池健康问题等'
        },
        {
          id: 1,
          title: '硬件维修、更换',
          tip: '包括屏幕/电池/摄像头维修、更换问题'
        },
        {
          id: 2,
          title: '功能使用问题',
          tip: '包括开关机问题、账号退出问题、锁屏密码、充电、屏幕显示、触控、指纹识别、面部识别、联网、拍照、蓝牙、维修痕迹等'
        },
        {
          id: 3,
          title: '外观问题',
          tip: '包括手机颜色、机身磨损程度、屏幕磨损程度等'
        }
      ],
      result: []
    }
  },
  watch: {
    result(val) {
      this.Finished({
        choosedIndexs: val,
        desc: this.desc.filter(item => val.includes(item.id)).map(item => item.title).join(',')
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>